import { render, staticRenderFns } from "./SaveIcon.vue?vue&type=template&id=03210b6e&scoped=true&"
import script from "./SaveIcon.vue?vue&type=script&lang=js&"
export * from "./SaveIcon.vue?vue&type=script&lang=js&"
import style0 from "./SaveIcon.vue?vue&type=style&index=0&id=03210b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03210b6e",
  null
  
)

export default component.exports